import { render } from "./CardMints.vue?vue&type=template&id=70558f00&scoped=true"
import script from "./CardMints.vue?vue&type=script&lang=js"
export * from "./CardMints.vue?vue&type=script&lang=js"

import "./CardMints.vue?vue&type=style&index=0&id=70558f00&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70558f00"]])

export default __exports__